<template>
  <li
    role="presentation"
    class="bg-white py-2 px-3 border-top position-sticky bottom-0"
  >
    <ul class="list-unstyled">
      <li
        role="presentation"
        class="d-flex align-items-center justify-content-between"
      >
        <BaseButton
          variant="outline-primary"
          size="sm"
          @click.stop="() => $emit('cancel')"
          >Cancel</BaseButton
        >
        <BaseButton :loading="isSaving" size="sm" @click.stop="handleSave"
          >Submit</BaseButton
        >
      </li>
    </ul>
  </li>
</template>

<script>
import Vue from 'vue'
import { defineComponent, inject, ref } from '@vue/composition-api'
import { createVuexHelpers } from 'vue2-helpers'

import { CompanyService } from '@services'
import { BaseButton } from '@components/base'

export default defineComponent({
  name: 'CompanyRLSDropdownFooter',
  components: {
    BaseButton
  },
  emits: ['cancel', 'saved'],
  setup(_, { emit }) {
    const { useGetters, useMutations } = createVuexHelpers()

    const { company } = useGetters(['company'])
    const { UPDATE_COMPANY_DATA: updateCompanyData } = useMutations([
      'UPDATE_COMPANY_DATA'
    ])

    const { rlsGroup, selectedItems } = inject('company-rls-dropdown')

    const isSaving = ref(false)

    const handleSave = async () => {
      isSaving.value = true

      try {
        const { data } = await CompanyService.put(
          company.value.id,
          {
            ...company.value,
            role_id: company.value.role.id,
            [`rls_${rlsGroup.toLowerCase()}_ids`]: selectedItems.value
          },
          {
            transformResponse: [
              (res) => {
                return {
                  ...JSON.parse(res),
                  noToastError: true
                }
              }
            ]
          }
        )
        const { data: results } = data || {}

        isSaving.value = false

        Vue.prototype.$toasted.show(`Company ${rlsGroup} updated successfully!`)

        updateCompanyData({
          key: `rls_${rlsGroup.toLowerCase()}_ids`,
          value: results.data[`rls_${rlsGroup.toLowerCase()}_ids`]
        })

        emit('saved')
      } catch (e) {
        const { data } = e.response || {}
        const { data: results } = data || {}
        const { error, message } = results || {}

        if (!!error) {
          const { default_report_id } = error || {}

          if (!!default_report_id) {
            Vue.prototype.$toasted.show('Default report ID cannot be null.', {
              type: 'error'
            })
          } else {
            Vue.prototype.$toasted.show(e.message, { type: 'error' })
          }
        } else {
          Vue.prototype.$toasted.show(message, { type: 'error' })
        }

        isSaving.value = false
      }
    }

    return {
      selectedItems,

      isSaving,
      handleSave
    }
  }
})
</script>
